import React, {Component, createRef} from 'react';
import logo from './logo.svg';
import './App.css';
import Tour from './components/Tour/Tour'
import Sidebar from "./components/Sidebar/Sidebar";

class App extends Component {
  state = {
    mounted: false
  }

  componentDidMount() {
    console.log(this.container)
    this.setState({mounted: true})
  }

  container = createRef();

  render() {
    const { mounted } = this.state;
    return (
        <div className="App" ref={this.container}>
          {mounted && <Tour container={this.container} />}
        </div>
    );
  }
}

export default App;
